import React from 'react';

const GroupDetail: React.FC = () => {
  return <div>GroupDetail</div>;
};

export default GroupDetail;
